import React, { Component } from "react";
import { List, ListItem } from "material-ui/List";
import Checkbox from "material-ui/Checkbox";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import styled from "styled-components";
import ReactMarkdown from "react-markdown";
import AppEvent from "./AppEvent";

class Flow extends Component {
  constructor(props) {
    super(props);

    this.state = { expanded: false };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(event) {
    this.setState({ expanded: !this.state.expanded });
  }

  render() {
    let details;
    if (this.state.expanded) {
      var that = this;
      let detailText;
      detailText = this.props.flow.spec;
      details = (
        <p style={{ textAlign: "left" }}>
          <ReactMarkdown source={detailText} />
        </p>
      );
    } else {
      details = "";
    }
    return (
      <Card
        style={{ width: "fit-content" }}
        onClick={e => {
          e.stopPropagation();
          this.handleClick(e);
        }}
      >
        <CardContent
          style={{
            padding: 12,
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <p style={{ textAlign: "left", fontSize: 12 }}>
            {this.props.flow.title}
            <div style={{ textAlign: "left", fontSize: 11 }}>{details}</div>
          </p>
          <p
            style={{
              color: "#883388",
              textAlign: "right",
              lineHeight: 0.8,
              fontSize: 14,
              paddingLeft: 10
            }}
          >
            {this.props.flow.typesOutput.map(event => {
              return (
                <div>
                  <span style={{ fontSize: 10, color: "#aaaaaa" }}>
                    {event.name}({event.type}){" "}
                  </span>
                </div>
              );
            })}
          </p>
        </CardContent>
      </Card>
    );
  }
}

export default Flow;



// WEBPACK FOOTER //
// ./src/components/Flow.js